import { useEffect, useState } from 'react';
import { VideoContent } from '../types/content';
import { liveVideoService } from '../services/lives';

export const useLiveVideo = () => {
  const [liveVideo, setLiveVideo] = useState<VideoContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchLiveVideo = async () => {
    try {
      setLoading(true);
      setError(null);
      const video = await liveVideoService.getLiveVideos();
      setLiveVideo(video);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch live video'));
      console.error('Error fetching live video:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLiveVideo();

    const interval = setInterval(() => {
      if (liveVideo?.broadcastStatus === 'live') {
        fetchLiveVideo();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return {
    liveVideo,
    loading,
    error,
    refetch: fetchLiveVideo
  };
}; 